// 基础配置文件

const dev = {
	API_URL: 'http://113.108.110.30:29005/nldmx-mobile-easyview-api/',
	BOSS_API_URL: 'http://trade.lutongnet.com:5000/v1/',
	LUTONG_USER_API_URL: 'http://119.23.172.90:9099/lutong-user-api/',
	RESOURCE_PATH: 'http://113.108.110.30:29005/nldmx-res/',
	COURSE_BUY_URL: 'https://cdn-jiaoyu-nldmx.vas.lutongnet.com/nldmx-res/phone/wx/test/index.html#/mindCourse',
	DOWNLOAD_URL: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.lutongnet.brainadventure.plugin',
	SHARE_URL: 'https://cdn-jiaoyu-nldmx.vas.lutongnet.com/nldmx-res/phone/wx/test/redirect.html',
	APP_CODE: 'BA82NKqN',
	CHANNEL_CODE: 'mobile_nldmx',
	APPID: '',
	MOBILE_APPID: '',
	PAY_TEST: true
};

const prod = {
	API_URL: 'https://api-jiaoyu-brain.vas.lutongnet.com:8887/nldmx-mb-api/',
	BOSS_API_URL: 'https://trade.lutongnet.com/v1/',
	LUTONG_USER_API_URL: 'https://api-jiaoyu-brain.vas.lutongnet.com:8887/lutong-user-api/',
	RESOURCE_PATH: 'https://cdn-jiaoyu-nldmx.vas.lutongnet.com/nldmx-res/',
	COURSE_BUY_URL: 'https://cdn-jiaoyu-nldmx.vas.lutongnet.com/nldmx-res/phone/wx/prod/index.html#/mindCourse',
	DOWNLOAD_URL: 'https://a.app.qq.com/o/simple.jsp?pkgname=com.lutongnet.brainadventure.plugin',
	SHARE_URL: 'https://cdn-jiaoyu-nldmx.vas.lutongnet.com/nldmx-res/phone/wx/prod/redirect.html',
	APP_CODE: '7vGp0ysb',
	CHANNEL_CODE: 'mobile_nldmx',
	APPID: '',
	MOBILE_APPID: '',
	PAY_TEST: false
};

export default process.env.VUE_APP_API === 'development' ? dev : prod;
